module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.3486/img/provider-signup/community-creators-image.png"